/* eslint-disable */

import { useMutation, useQueryClient } from '@tanstack/react-query';
import React, { useEffect, useRef, useState } from 'react';
import client from '../../../api/client';
import { Link } from 'react-router-dom';
import ModalLoad from '../../../components/modal/ModalLoad';
import ModalPopupMessage from '../../../components/modal/ModalPopupMessage';
import BarcodeScanner from '../../../components/scanner/BarcodeScanner';

import '../../../components/dropdown/SearchProductOption.css';

import moment from 'moment';
import PropTypes from 'prop-types';

import { DatePicker } from 'antd';
import th from 'antd/es/date-picker/locale/th_TH';
import dayjs from 'dayjs';
import dayTh from 'dayjs/locale/th';
import buddhistEra from 'dayjs/plugin/buddhistEra';
import { useDetectClickOutside } from 'react-detect-click-outside';
import { colors } from '../../../helper/constant/colors';
import { useLoadConfig } from '../../../hooks/useLoadConfig';

dayjs.extend(buddhistEra);
dayjs.locale(dayTh);

function MyShop_Seller_NewProduct(props) {
  const queryClient = useQueryClient();
  const shopId = props.permitdata?.shop_id;
  const loadConfig = useLoadConfig(props.permitdata);
  const sellLicenses = loadConfig.sellLicenses;
  const catalogEmpty =
    !props.productCatalog.loading && (props.productCatalog.products?.length ?? 0) === 0;
  const noSellLicenseAccess = sellLicenses.length === 0;

  const [productitemlist, setProductitemlist] = useState([]);
  const [productitemlist_filter, setProductitemlist_filter] = useState([]);
  const [filtertext, setFiltertext] = useState('');
  const [productitem_selected, setProductitem_selected] = useState({});
  const [isScannerOpen, setIsScannerOpen] = useState(false);

  const [tableitem, setTableitem] = useState([
    {
      id: moment(new Date()).format('YYYYMMDDHHmmssSSS'),
      unit: '',
      stock: '',
      price: '',
      pricepromotion: '',
      expire: moment(new Date()).format('YYYY-MM-DD'),
    },
  ]);
  const [tablestock, setTablestock] = useState([
    { expire: moment(new Date()).format('YYYY-MM-DD'), stock: 0 },
  ]);
  const [searchoption, setSearchoption] = useState(false);
  const [trigerstock, setTrigerstock] = useState(false);
  const [sortdata, setSortdata] = useState(false);
  const [modal_load, setmodal_load] = useState({ enable: false, message: '' });
  const [modal_popup, setModal_popup] = useState({
    modaltype: '',
    headers: '',
    message: '',
    enable: false,
  });

  const sleep = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

  const addShopItemMutation = useMutation({
    mutationFn: async (formData) => {
      await sleep(200);
      const response = await client.post('/api/product/shopitem/add', formData, {
        headers: {
          Accept: 'application/json',
          'Content-Type': 'multipart/form-data;',
        },
      });
      return response.data;
    },
    onSuccess: (data) => {
      setmodal_load({ enable: false, message: '' });
      if (data.status !== 'OK') {
        setModal_popup({
          modaltype: 'modal-warning',
          headers: 'ขออภัย',
          message: data.message,
          enable: true,
        });
        return;
      }

      queryClient.invalidateQueries({ queryKey: ['load-config', shopId] });
      props.callback_datachanged('shopitem-add', data.items);
      setModal_popup({
        modaltype: 'modal-success',
        headers: 'สำเร็จ',
        message: data.message,
        enable: true,
      });
    },
    onError: (err) => {
      setmodal_load({ enable: false, message: '' });
      setModal_popup({
        modaltype: 'modal-error',
        headers: 'ผิดพลาด',
        message: err.message,
        enable: true,
      });
    },
  });

  const popupref = useDetectClickOutside({ onTriggered: closesearchoption });
  function closesearchoption() {
    setSearchoption(false);
  }

  function showDialogCallback_General(message) {
    if (modal_popup.modaltype === 'modal-success') {
      window.location.reload();
    }
    setModal_popup({
      modaltype: '',
      headers: '',
      message: '',
      enable: false,
    });
  }

  function showDialogCallback_Confirm(message) { }

  const buddhistLocale = {
    ...th,
    lang: {
      ...th.lang,
      fieldDateFormat: 'BBBB-MMM-DD',
      fieldDateTimeFormat: 'BBBB-MMM-DD HH:mm:ss',
      yearFormat: 'BBBB',
      cellYearFormat: 'BBBB',
    },
  };

  useEffect(() => {
    if (props.productCatalog?.search) {
      props.productCatalog.search('', 'seller_category');
    }
  }, []);

  useEffect(() => {
    const catalogProducts = props.productCatalog?.products;
    if (Array.isArray(catalogProducts)) {
      setProductitemlist(catalogProducts);
      setProductitemlist_filter(catalogProducts);
    }
  }, [props.productCatalog?.products]);

  const searchDebounce = useRef(null);
  useEffect(() => {
    if (!props.productCatalog?.search || !searchoption) return undefined;
    clearTimeout(searchDebounce.current);
    searchDebounce.current = setTimeout(() => {
      props.productCatalog.search(filtertext, 'seller_category');
    }, 350);
    return () => clearTimeout(searchDebounce.current);
  }, [filtertext, searchoption, props.productCatalog]);

  function selectstock(expire, val) {
    const nexttableitem = tablestock.map((item) => {
      if (item.expire !== expire) {
        return item;
      } else {
        return {
          ...item,
          stock: val,
        };
      }
    });
    setTablestock(nexttableitem);
  }

  function selectnumber(id, val, keys) {
    if (keys === 'stock') {
      const currentItem = tableitem.find((item) => item.id === id);
      const targetExpire = currentItem ? currentItem.expire : null;
      const nexttableitem = tableitem.map((item) => {
        if (item.id === id || (targetExpire && item.expire === targetExpire)) {
          return {
            ...item,
            stock: val,
          };
        }
        return item;
      });
      setTableitem(nexttableitem);
    } else {
      const nexttableitem = tableitem.map((item) => {
        if (item.id !== id) {
          return item;
        } else {
          return {
            ...item,
            [keys]: val,
          };
        }
      });
      setTableitem(nexttableitem);
    }
    setSortdata(false);
  }

  function selectepiredate(id, date, datestr) {
    if (date !== null) {
      const formattedDate = date.format('YYYY-MM-DD');
      const existingItem = tableitem.find(
        (item) => item.id !== id && item.expire === formattedDate && item.stock !== undefined && item.stock !== '',
      );
      const existingStockInTablestock = tablestock.find((s) => s.expire === formattedDate);
      const newStock = existingItem
        ? existingItem.stock
        : existingStockInTablestock && existingStockInTablestock.stock !== undefined && existingStockInTablestock.stock !== ''
          ? existingStockInTablestock.stock
          : '';

      const nexttableitem = tableitem.map((item) => {
        if (item.id !== id) {
          return item;
        } else {
          return {
            ...item,
            expire: formattedDate,
            stock: newStock,
          };
        }
      });
      setTableitem(nexttableitem);
    }
    setSortdata(false);
  }

  function addpricelist() {
    if (tableitem.length < 10) {
      var id = moment(new Date()).format('YYYYMMDDHHmmssSSS');
      var lastItem = tableitem.length > 0 ? tableitem[tableitem.length - 1] : null;
      var exp = lastItem && lastItem.expire ? lastItem.expire : moment(new Date()).format('YYYY-MM-DD');

      const existingItem = tableitem.find(
        (item) => item.expire === exp && item.stock !== undefined && item.stock !== '',
      );
      const stockVal = existingItem ? existingItem.stock : lastItem && lastItem.stock ? lastItem.stock : '';

      setTableitem((oldArray) => [
        ...oldArray,
        { id: id, unit: '', stock: stockVal, price: '', pricepromotion: '', expire: exp },
      ]);
    } else {
      setModal_popup({
        modaltype: 'modal-warning',
        headers: 'ขออภัย',
        message: 'ท่านสามารถใส่ราคาย่อยได้สูงสุด 10 รายการ',
        enable: true,
      });
    }
    setSortdata(false);
  }

  function removepricelist(id) {
    if (tableitem.length > 1) {
      setTableitem(
        tableitem.filter(function (item) {
          return item.id !== id;
        }),
      );
    } else {
      setModal_popup({
        modaltype: 'modal-warning',
        headers: 'ขออภัย',
        message: 'ตารางราคาต้องมีอย่างน้อย 1 รายการ',
        enable: true,
      });
    }
    setSortdata(false);
  }

  useEffect(() => {
    let newStockMap = {};
    for (const item of tableitem) {
      if (newStockMap[item.expire] === undefined || (newStockMap[item.expire] === '' && item.stock !== undefined && item.stock !== '')) {
        newStockMap[item.expire] = item.stock || '';
      } else if (item.stock !== undefined && item.stock !== '') {
        newStockMap[item.expire] = item.stock;
      }
    }
    const nextTablestock = Object.keys(newStockMap).map(expire => ({
      expire: expire,
      stock: newStockMap[expire]
    }));
    setTablestock(nextTablestock);
  }, [tableitem]);

  function sortitem() {
    setTableitem(
      [...tableitem].sort(
        (firstItem, secondItem) =>
          dayjs(firstItem.expire).valueOf() - dayjs(secondItem.expire).valueOf() ||
          Number(firstItem.unit) - Number(secondItem.unit),
      ),
    );
    setTablestock(
      [...tablestock].sort(
        (firstItem, secondItem) =>
          dayjs(firstItem.expire).valueOf() - dayjs(secondItem.expire).valueOf(),
      ),
    );
    setSortdata(true);
  }

  function api_add_shopitem() {
    var formstockelement = document.getElementById('form-stock');
    var formpriceelement = document.getElementById('form-price');
    const hasSelectedProduct = Boolean(productitem_selected?.productitem_id);
    if (
      formpriceelement.checkValidity() === false ||
      formstockelement.checkValidity() === false ||
      !hasSelectedProduct
    ) {
      formstockelement.classList.add('was-validated');
      formpriceelement.classList.add('was-validated');

      setModal_popup({
        modaltype: 'modal-warning',
        headers: 'ขออภัย',
        message: 'กรุณากรอกข้อมูลให้ครบถ้วน',
        enable: true,
      });
    } else {
      formstockelement.classList.remove('was-validated');
      formpriceelement.classList.remove('was-validated');

      if (tableitem.length > 0) {
        if (sortdata === true || tableitem.length === 1) {
          var temp = [];
          var proprice_found = false;
          var proprice_error = false;
          var stocksum = 0;
          var on_stock = [];
          var on_sold = '';

          var firstprice_unit = '';
          var firstprice_price = '';
          var firstprice_new = '';
          var firstprice_expire = '';
          var firstprice_stock = '';

          const formData = new FormData();
          tablestock.forEach((item, index) => {
            var x = item.expire + '**' + item.stock;
            on_stock.push(x);
            stocksum += Number(item.stock);
          });
          var duplcateref = [];
          var duplcatebit = false;
          tableitem.forEach((item, index) => {
            var dp = item.unit + '**' + item.expire;
            var fnd_dp = duplcateref.find((element) => {
              return element === dp;
            });
            if (fnd_dp !== undefined) {
              duplcatebit = true;
            }
            duplcateref.push(dp);

            var x = item.unit + '**' + item.price + '**' + (item.pricepromotion || '0') + '**' + item.expire;
            temp.push(x);
            on_sold = '0';
            if (firstprice_unit === '') {
              firstprice_unit = item.unit;
              firstprice_price = item.price;
              firstprice_new = item.pricepromotion || '0';
              firstprice_expire = item.expire;
              var fnd = tablestock.find((element) => {
                return element.expire === item.expire;
              });
              if (fnd !== undefined) {
                firstprice_stock = fnd.stock;
              }
            }

            if (
              proprice_found === false &&
              Number(item.pricepromotion) > 0 &&
              Number(item.pricepromotion) < Number(item.price)
            ) {
              proprice_found = true;
              formData.append('first_priceunit', item.unit);
              formData.append('first_pricebase', item.price);
              formData.append('first_pricenew', item.pricepromotion || '0');
              formData.append('first_expire', item.expire);
              var fndd = tablestock.find((element) => {
                return element.expire === item.expire;
              });
              if (fndd !== undefined) {
                formData.append('first_stock', fndd.stock);
              }
            }

            if (
              Number(item.pricepromotion) > 0 &&
              Number(item.pricepromotion) >= Number(item.price)
            ) {
              proprice_error = true;
            }
          });

          if (proprice_error === true) {
            setModal_popup({
              modaltype: 'modal-warning',
              headers: 'ขออภัย',
              message: 'ราคาโปรโมชั่นจะต้องน้อยกว่าราคาขายปกติ',
              enable: true,
            });
          } else {
            if (duplcatebit === false) {
              var pricestring = temp.join('##');
              formData.append('shop_id', props.permitdata.shop_id);
              formData.append('shop_name', props.permitdata.shop_name);
              formData.append('shop_province', props.permitdata.shop_province);
              formData.append('productitem_id', productitem_selected.productitem_id || '');
              formData.append('productitem_name', productitem_selected.productitem_name || '');
              formData.append('productitem_inter', productitem_selected.productitem_inter || '');
              formData.append('img1_key', productitem_selected.img1_key || '');

              if (proprice_found === false) {
                formData.append('first_priceunit', firstprice_unit);
                formData.append('first_pricebase', firstprice_price);
                formData.append('first_pricenew', firstprice_new || '0');
                formData.append('first_expire', firstprice_expire);
                formData.append('first_stock', firstprice_stock);
                formData.append('ispro', 'False');
              } else {
                formData.append('ispro', 'True');
              }
              formData.append('ads', 'False');
              formData.append('status', 'OnSell');
              if (stocksum > 0) {
                formData.append('isblank', 'False');
              } else {
                formData.append('isblank', 'True');
              }

              formData.append('pricetable', pricestring);
              formData.append('on_sold', on_sold);
              formData.append('on_stock', on_stock.join('##'));
              formData.append('username', props.permitdata.shop_username);

              setmodal_load({ enable: true, message: 'กำลังลงขายสินค้า' });
              addShopItemMutation.mutate(formData);
            } else {
              setModal_popup({
                modaltype: 'modal-warning',
                headers: 'ขออภัย',
                message: 'ตรวจพบจำนวนชิ้นต่อชุดซ้ำกัน (แยกตามวันหมดอายุ)',
                enable: true,
              });
            }
          }
        } else {
          setModal_popup({
            modaltype: 'modal-warning',
            headers: 'ขออภัย',
            message: 'กรุณากดปุ่ม "เรียงตารางราคาใหม่"',
            enable: true,
          });
        }
      } else {
        setModal_popup({
          modaltype: 'modal-warning',
          headers: 'ขออภัย',
          message: 'ไม่พบตารางราคา',
          enable: true,
        });
      }
    }
  }

  return (
    <div className='my-0 font-inter font-th'>
      {catalogEmpty && noSellLicenseAccess ? (
        <div
          className='alert alert-warning font-th'
          style={{ borderRadius: '10px', marginBottom: '12px' }}
          role='alert'
        >
          ยังไม่ได้รับอนุญาตใบทะเบียน — ติดต่อ Line @meya
          <br />
          <small>ร้านจะเลือกสินค้าขายได้เมื่อได้รับใบทะเบียนที่มีสิทธิ์ขาย (ซื้อ+ขาย หรือ ขายเท่านั้น) จากทีมงานแล้ว</small>
        </div>
      ) : null}
      {/* Search Product Section */}
      <div className='row mb-3'>
        <div className='col-12 pl-3'>
          <div
            className='me-card'
            style={{
              borderRadius: '12px',
              border: `1px solid ${colors.borderLight}`,
              boxShadow: '0 2px 8px rgba(0,0,0,0.02)',
              overflow: 'visible',
            }}
          >
            <div className='me-card-body p-3' style={{ overflow: 'visible' }}>
              <div className='d-flex align-items-center mb-2'>
                <i className='fas fa-search mr-2' style={{ fontSize: '15px', color: colors.blueLight }}></i>
                <h6 className='font-th font-weight-bold text-dark mb-0' style={{ fontSize: '15px' }}>ค้นหาและเลือกสินค้าที่ต้องการลงขาย</h6>
              </div>

              <div
                className='search-card position-relative'
                ref={popupref}
                style={{ border: 'none', padding: 0, overflow: 'visible' }}
              >
                <div
                  className='input-with-icon'
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    backgroundColor: '#f8fbff',
                    border: `1px solid ${colors.borderLight}`,
                    borderRadius: '8px',
                    padding: '4px 12px',
                  }}
                >
                  <i
                    className='fas fa-search search-icon mr-2'
                    style={{ color: colors.blueLight }}
                  ></i>
                  <input
                    type='text'
                    className='search-input font-th border-0 bg-transparent'
                    name='productitem_name'
                    id='productitem_name'
                    placeholder='กรอกชื่อสินค้าภาษาไทย ภาษาอังกฤษ หรือรหัสสินค้า...'
                    autoComplete='new-off'
                    value={filtertext}
                    onChange={(e) => {
                      setFiltertext(e.target.value);
                      setSearchoption(true);
                    }}
                    onClick={() => setSearchoption(true)}
                    onFocus={() => setSearchoption(true)}
                    required
                    style={{ flex: 1, outline: 'none' }}
                  />
                  {filtertext && (
                    <button
                      type='button'
                      onClick={() => setFiltertext('')}
                      className='btn btn-sm text-muted p-0 mr-2 border-0 bg-transparent'
                      title='ล้างคำค้นหา'
                    >
                      <i className='fas fa-times-circle'></i>
                    </button>
                  )}
                  <button
                    type='button'
                    title='สแกนบาร์โค้ด'
                    onClick={() => setIsScannerOpen(true)}
                    className='btn btn-sm d-flex align-items-center'
                    style={{
                      backgroundColor: colors.white,
                      border: `1px solid ${colors.blueLight}`,
                      borderRadius: '6px',
                      padding: '4px 10px',
                      color: colors.bluePrimary,
                      flexShrink: 0,
                    }}
                  >
                    <i className='fas fa-barcode mr-1' style={{ color: colors.blueLight }}></i>
                    <span className='font-th d-none d-sm-inline' style={{ fontSize: '12px' }}>
                      สแกนบาร์โค้ด
                    </span>
                  </button>
                </div>

                {searchoption === true && (
                  <div
                    className='product-option'
                    style={{
                      position: 'absolute',
                      top: '100%',
                      left: 0,
                      right: 0,
                      zIndex: 100,
                      marginTop: '6px',
                      borderRadius: '8px',
                      boxShadow: '0 8px 24px rgba(33, 150, 243, 0.12)',
                      border: `1px solid ${colors.borderLight}`,
                      backgroundColor: colors.white,
                      maxHeight: '300px',
                      overflowY: 'auto',
                    }}
                  >
                    <div className='meya-table-console-wrapper p-2'>
                      <table className='table meya-table-console font-th mb-0 table-hover'>
                        <thead>
                          <tr style={{ backgroundColor: '#f1f7fe' }}>
                            <th width='50px' className='text-center border-0' style={{ color: colors.slate600 }}>
                              #
                            </th>
                            <th className='border-0' style={{ color: colors.slate600 }}>
                              ชื่อสินค้าภาษาไทย/อังกฤษ
                            </th>
                            <th
                              width='130px'
                              className='border-0 text-right'
                              style={{ color: colors.slate600 }}
                            >
                              รหัสสินค้า
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          {props.productCatalog?.loading ? (
                            <tr>
                              <td colSpan='3' className='text-center py-3 text-muted'>
                                <i className='fas fa-spinner fa-spin mr-2 text-primary'></i>
                                กำลังค้นหาสินค้า...
                              </td>
                            </tr>
                          ) : productitemlist_filter.length > 0 ? (
                            productitemlist_filter.map((product, index) => (
                              <tr
                                className={
                                  'meya-table-console-row search-item cursor-pointer ' +
                                  (product.productitem_id === productitem_selected.productitem_id
                                    ? 'active'
                                    : '')
                                }
                                onClick={() => {
                                  setProductitem_selected(product);
                                  setSearchoption(false);
                                  setFiltertext(product.productitem_name || '');
                                }}
                                key={product.productitem_id || index}
                              >
                                <td className='text-center align-middle font-weight-bold text-muted'>
                                  {index + 1}
                                </td>
                                <td className='py-2 align-middle'>
                                  <div className='font-weight-600 text-dark' style={{ lineHeight: 1.45, marginBottom: product.productitem_inter ? '4px' : 0 }}>
                                    {product.productitem_name}
                                  </div>
                                  {product.productitem_inter && (
                                    <div className='text-muted font-en' style={{ fontSize: '12px', lineHeight: 1.4 }}>
                                      {product.productitem_inter}
                                    </div>
                                  )}
                                </td>
                                <td className='text-right align-middle'>
                                  <span
                                    className='badge px-2 py-1'
                                    style={{
                                      borderRadius: '4px',
                                      background: colors.blueSoft,
                                      border: `1px solid ${colors.blueLight}`,
                                      color: colors.bluePrimary,
                                    }}
                                  >
                                    {product.productitem_id}
                                  </span>
                                </td>
                              </tr>
                            ))
                          ) : (
                            <tr>
                              <td colSpan='3' className='text-center py-3 text-muted'>
                                {noSellLicenseAccess
                                  ? 'ยังไม่ได้รับอนุญาตใบทะเบียน — ติดต่อ Line @meya'
                                  : filtertext
                                  ? 'ไม่พบสินค้าที่ตรงกับคำค้นหา'
                                  : 'พิมพ์ชื่อสินค้าหรือรหัสสินค้าเพื่อค้นหา'}
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    </div>
                  </div>
                )}
              </div>

              <div className='note-message note-message-info mt-2'>
                *หมายเหตุ: หากค้นหาไม่พบสินค้าที่ต้องการ กรุณาติดต่อ Line OA: <b>@meya</b> เพื่อเพิ่มรายการสินค้า
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Selected Product Card */}
      <div className='row mb-3'>
        <div className='col-md-12 pl-3'>
          <div className='me-card' style={{ borderRadius: '12px', border: `1px solid ${colors.borderLight}`, boxShadow: '0 2px 8px rgba(0,0,0,0.02)' }}>
            <div className='me-card-body p-3'>
              <div className='d-flex align-items-center mb-2'>
                <i className='fas fa-box-open mr-2' style={{ fontSize: '15px', color: colors.blueLight }}></i>
                <h6 className='font-th font-weight-bold text-dark mb-0' style={{ fontSize: '15px' }}>ข้อมูลสินค้าที่เลือก</h6>
              </div>

              {productitem_selected.productitem_id !== undefined ? (
                <div className='d-flex align-items-start mt-2'>
                  <div className='new-product mr-3'>
                    <div className='img-wrapper' style={{ width: '100px', height: '100px', maxWidth: '100px', maxHeight: '100px' }}>
                      {productitem_selected.productitem_id !== undefined ? (
                        <img
                          src={
                            `${process.env.REACT_APP_IMAGE_URL}` +
                            productitem_selected.productitem_id +
                            '/' +
                            productitem_selected.productitem_id +
                            '-1-' +
                            productitem_selected.img1_key +
                            '.jpg'
                          }
                          alt='product-img'
                          onError={(e) => { e.target.src = '/images/medicine/blank.png'; }}
                        />
                      ) : (
                        <img src='/images/medicine/blank.png' alt='product-img' />
                      )}
                    </div>
                  </div>
                  <div className='flex-1 product-detail'>
                    <div className='font-th text-success font-weight-bold mb-1' style={{ fontSize: '13px' }}>
                      <i className='fas fa-check-circle mr-1'></i>รหัสสินค้า: {productitem_selected.productitem_id}
                    </div>
                    <div className='font-th font-weight-bold text-dark mt-0 mb-1' style={{ fontSize: '16px' }}>
                      {productitem_selected.productitem_name}
                    </div>
                    <div className='product-desc font-en text-muted mt-0' style={{ fontSize: '13px' }}>
                      {productitem_selected.productitem_inter}
                    </div>
                  </div>
                </div>
              ) : (
                <div className='text-center py-3 text-muted font-th' style={{ backgroundColor: '#f8f9fa', borderRadius: '8px', border: `1px dashed ${colors.borderLight}`, fontSize: '13px' }}>
                  ยังไม่ได้เลือกสินค้า กรุณาพิมพ์ค้นหาและเลือกรายการสินค้าจากช่องค้นหาด้านบน
                </div>
              )}

              {productitem_selected.productitem_id !== undefined && (
                <div className='mt-3 pt-2' style={{ borderTop: `1px solid #f0f0f0` }}>
                  <label className='font-th font-weight-bold mb-1' style={{ fontSize: '13px', color: '#555' }}>รายละเอียดสินค้า</label>
                  <textarea
                    className='form-control font-th'
                    rows={4}
                    value={productitem_selected.productitem_desc || ''}
                    readOnly
                    style={{ borderRadius: '6px', backgroundColor: '#f8f9fa', fontSize: '13px' }}
                  />
                </div>
              )}
            </div>
          </div>
        </div>
      </div>

      {/* Sales Data & Pricing Card */}
      <div className='row mb-3'>
        <div className='col-md-12 pl-3'>
          <div className='me-card' style={{ borderRadius: '12px', border: `1px solid ${colors.borderLight}`, boxShadow: '0 2px 8px rgba(0,0,0,0.02)' }}>
            <div className='me-card-body p-3'>
              <div className='d-flex justify-content-between align-items-center mb-3'>
                <div className='d-flex align-items-center'>
                  <i className='fas fa-tags text-primary mr-2' style={{ fontSize: '15px' }}></i>
                  <h6 className='font-th font-weight-bold text-dark mb-0' style={{ fontSize: '15px' }}>ข้อมูลการขายและตารางราคา</h6>
                </div>
              </div>

              {/* Stock Summary */}
              <div className='mb-3'>
                <label className='font-th text-gray-111 font-weight-bold mb-2' style={{ fontSize: '14px' }}>ตารางจำนวนคงเหลือ</label>
                <form id='form-stock' onSubmit={(e) => e.preventDefault()}>
                  <div className='price-table font-th px-0' id='pricetable'>
                    <div className='price-table-row px-0 mb-2'>
                      <div className='price-table-cell font-weight-bold' style={{ width: '150px', flex: '0 0 150px' }}>
                        วันหมดอายุ
                      </div>
                      <div className='price-table-cell font-weight-bold'>คงเหลือ (ชิ้น)</div>
                    </div>
                    {tablestock.map((item) => (
                      <div className='price-table-row align-items-center mb-2' key={item.expire}>
                        <div className='price-table-cell' style={{ width: '150px', flex: '0 0 150px' }}>
                          <i className='far fa-calendar-alt text-muted mr-1'></i>
                          {dayjs(item.expire).format('DD MMM YYYY')}
                        </div>
                        <div className='price-table-cell'>
                          <input
                            type='number'
                            className='form-control font-th'
                            name='pricelist-price'
                            placeholder='จำนวน'
                            min='0'
                            value={item.stock}
                            onChange={(e) => selectstock(item.expire, e.target.value)}
                            autoComplete='off'
                            readOnly
                            required
                            style={{ borderRadius: '6px', maxWidth: '180px', backgroundColor: '#e9ecef', fontWeight: '600' }}
                          />
                        </div>
                      </div>
                    ))}
                  </div>
                </form>
              </div>

              <hr className='my-3' style={{ borderTop: `1px solid ${colors.borderLight}` }} />

              {/* Price Tiers */}
              <div className='d-flex justify-content-between align-items-center mb-3 mt-2'>
                <div>
                  <div className='font-th font-weight-bold' style={{ fontSize: '15px', color: '#1a1a1a' }}>ช่วงราคาขาย</div>
                  <div className='font-th text-muted' style={{ fontSize: '12px' }}>กำหนดราคาตามจำนวนซื้อขั้นต่ำที่ลูกค้าซื้อ</div>
                </div>
                <button
                  type="button"
                  className='btn font-th d-flex align-items-center justify-content-center'
                  style={{ backgroundColor: '#e3f2fd', color: colors.bluePrimary, border: 'none', borderRadius: '6px', padding: '6px 14px', fontSize: '13px', fontWeight: '600' }}
                  onClick={() => addpricelist()}
                >
                  <i className='fas fa-plus mr-1' style={{ fontSize: '12px' }}></i>
                  เพิ่มช่วงราคา
                </button>
              </div>

              <form id='form-price' onSubmit={(e) => e.preventDefault()}>
                <div style={{ border: `1px solid ${colors.borderLight}`, borderRadius: '8px', overflow: 'hidden' }}>
                  <div className="d-none d-md-flex row mx-0 px-3 font-th font-weight-bold text-center py-2" style={{ backgroundColor: '#f8f9fa', borderBottom: `1px solid ${colors.borderLight}`, fontSize: '13px', color: '#444' }}>
                    <div className="col-md-2 px-1">จำนวนชิ้น</div>
                    <div className="col-md-2 px-1">คงเหลือ (ชิ้น)</div>
                    <div className="col-md-2 px-1">ราคาปกติ (บาท)</div>
                    <div className="col-md-2 px-1">ราคาขายช่วงโปร (บาท)</div>
                    <div className="col-md-3 px-1">วันหมดอายุ</div>
                    <div className="col-md-1 px-1">จัดการ</div>
                  </div>

                  <div className="px-3">
                    {tableitem.map((item, index) => (
                      <div key={item.id} className="row mx-0 align-items-center py-2" style={{ borderBottom: index < tableitem.length - 1 ? `1px solid ${colors.borderLight}` : 'none' }}>

                        <div className="col-12 col-md-2 px-1 mb-2 mb-md-0 d-flex flex-row flex-md-row align-items-center justify-content-between justify-content-md-center">
                          <span className="d-md-none font-th mb-0 text-dark" style={{ width: '130px', textAlign: 'left', fontSize: '13px' }}>จำนวนชิ้น</span>
                          <div className="d-flex align-items-center" style={{ flex: 1, maxWidth: '250px' }}>
                            <input type="number" className="form-control font-th text-center w-100" style={{ borderRadius: '6px' }} value={item.unit} onChange={(e) => selectnumber(item.id, e.target.value, 'unit')} min="1" placeholder="จำนวนชิ้นต่อชุด" required />
                          </div>
                        </div>

                        <div className="col-12 col-md-2 px-1 mb-2 mb-md-0 d-flex flex-row flex-md-column align-items-center justify-content-between justify-content-md-center">
                          <span className="d-md-none font-th mb-0 text-dark" style={{ width: '130px', textAlign: 'left', fontSize: '13px' }}>คงเหลือ (ชิ้น)</span>
                          <div style={{ flex: 1, maxWidth: '250px' }}>
                            <input type="number" className="form-control font-th text-center w-100 font-weight-bold" style={{ borderRadius: '6px' }} value={item.stock} onChange={(e) => selectnumber(item.id, e.target.value, 'stock')} min="0" placeholder="จำนวน" required />
                          </div>
                        </div>

                        <div className="col-12 col-md-2 px-1 mb-2 mb-md-0 d-flex flex-row flex-md-column align-items-center justify-content-between justify-content-md-center">
                          <span className="d-md-none font-th mb-0 text-dark" style={{ width: '130px', textAlign: 'left', fontSize: '13px' }}>ราคารวมปกติ</span>
                          <div style={{ flex: 1, maxWidth: '250px' }}>
                            <input type="number" className="form-control font-th text-center w-100" style={{ borderRadius: '6px' }} value={item.price} onChange={(e) => selectnumber(item.id, e.target.value, 'price')} min="1" placeholder="ราคาปกติ" required />
                          </div>
                        </div>

                        <div className="col-12 col-md-2 px-1 mb-2 mb-md-0 d-flex flex-row flex-md-column align-items-center justify-content-between justify-content-md-center">
                          <span className="d-md-none font-th mb-0 text-dark" style={{ width: '130px', textAlign: 'left', fontSize: '13px' }}>ราคารวมโปรโมชั่น</span>
                          <div style={{ flex: 1, maxWidth: '250px' }}>
                            <input type="number" className="form-control font-th text-center text-danger w-100" style={{ borderRadius: '6px' }} value={item.pricepromotion} onChange={(e) => selectnumber(item.id, e.target.value, 'pricepromotion')} min="0" placeholder="ราคาโปรโมชั่น" />
                          </div>
                        </div>

                        <div className="col-12 col-md-3 px-1 mb-2 mb-md-0 d-flex flex-row flex-md-column align-items-center justify-content-between justify-content-md-center">
                          <span className="d-md-none font-th mb-0 text-dark" style={{ width: '130px', textAlign: 'left', fontSize: '13px' }}>วันหมดอายุ</span>
                          <div style={{ flex: 1, maxWidth: '250px' }}>
                            <DatePicker
                              allowClear={false}
                              locale={buddhistLocale}
                              onChange={(date, dateString) => selectepiredate(item.id, date, dateString)}
                              className={'form-control text-center w-100'}
                              value={item.expire ? dayjs(item.expire) : null}
                              defaultPickerValue={item.expire ? dayjs(item.expire) : dayjs()}
                              style={{ borderRadius: '6px' }}
                            />
                          </div>
                        </div>

                        <div className="col-12 col-md-1 px-1 mt-2 mt-md-0 d-flex justify-content-end justify-content-md-center">
                          <button
                            type='button'
                            className='btn text-danger bg-transparent p-0 border-0 d-flex align-items-center'
                            onClick={() => removepricelist(item.id)}
                            title='ลบรายการนี้'
                          >
                            <i className='fe-trash-2' style={{ fontSize: '16px' }}></i> <span className="d-md-none ml-2 font-th" style={{ fontSize: '13px' }}>ลบรายการนี้</span>
                          </button>
                        </div>

                        {index < tableitem.length - 1 && <div className="col-12 d-md-none mt-2"><hr className="m-0" style={{ borderTop: '1px solid #eee' }} /></div>}
                      </div>
                    ))}
                  </div>
                </div>
              </form>

              <div className='mt-3 p-3' style={{ backgroundColor: '#f8f9fa', borderRadius: '8px', display: 'flex', alignItems: 'flex-start' }}>
                <i className='fe-info text-primary mt-1 mr-2'></i>
                <div>
                  <div className='font-weight-bold text-primary font-th' style={{ fontSize: '13px' }}>คำแนะนำการกำหนดช่วงราคาขาย</div>
                  <div className='text-muted font-th' style={{ fontSize: '12px' }}>
                    สามารถกำหนดช่วงราคาขายได้สูงสุด 10 รายการ หากมีวันหมดอายุเดียวกัน ยอดคงเหลือจะซิงค์ให้อัตโนมัติ หากเป็นวันหมดอายุใหม่ สามารถกรอกจำนวนคงเหลือประจำวันหมดอายุนั้นๆ ได้ตามต้องการ
                  </div>
                </div>
              </div><br />
              {/* Action Buttons */}
              <div className='col-md-12 mb-2 pl-3'>
                <div className='d-flex align-items-center mb-3'>
                  <div>
                    <button
                      type='button'
                      className='btn btn-rectan-small px-3 btn-primary font-th text-white cursor-pointer border-0 d-flex align-items-center'
                      onClick={() => sortitem()}
                    >
                      <i className='fas fa-sort-amount-down mr-2' style={{ fontSize: '12px' }}></i>
                      เรียงตารางราคา
                    </button>
                  </div>
                  <div className='ml-3'>
                    <button
                      type='button'
                      className='btn btn-rectan-small px-4 btn-warning font-th text-dark font-weight-bold cursor-pointer border-0 d-flex align-items-center'
                      onClick={() => api_add_shopitem()}
                    >
                      <i className='fas fa-check-circle mr-2' style={{ fontSize: '13px' }}></i>
                      ลงขายสินค้า
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <ModalLoad option={modal_load}></ModalLoad>
        <ModalPopupMessage
          callback_general={(message) => {
            showDialogCallback_General(message);
          }}
          callback_confirm={(message) => {
            showDialogCallback_Confirm(message);
          }}
          options={modal_popup}
        />
      </div>

      {isScannerOpen && (
        <BarcodeScanner
          onScanSuccess={(code) => {
            setIsScannerOpen(false);
            if (!code) return;
            const scanCode = String(code).trim();
            setFiltertext(scanCode);
            setSearchoption(true);
            const norm = (s) =>
              String(s || '')
                .replace(/[^a-zA-Z0-9]/g, '')
                .toLowerCase();
            const searchNorm = norm(scanCode);
            const found = productitemlist.find(
              (item) =>
                (item.productitem_barcode &&
                  norm(item.productitem_barcode) === searchNorm) ||
                (item.productitem_id && norm(item.productitem_id) === searchNorm),
            );
            if (found) {
              setProductitem_selected(found);
              setSearchoption(false);
            }
          }}
          onClose={() => setIsScannerOpen(false)}
        />
      )}
    </div>
  );
}

MyShop_Seller_NewProduct.propTypes = {
  callback_datachanged: PropTypes.func,
  productCatalog: PropTypes.object,
  permitdata: PropTypes.object,
};

export default MyShop_Seller_NewProduct;
